import React, { useCallback } from "react";
import { Text, StyleSheet, View, Button, TouchableOpacity, Image, SafeAreaView, Linking, ScrollView } from "react-native";
import Constants from 'expo-constants';

const OpenURLButton = ({ url, children }) => {
  const handlePress = useCallback(async () => {
    // Checking if the link is supported for links with custom URL scheme.
    const supported = await Linking.canOpenURL(url);

    if (supported) {
      // Opening the link with some app, if the URL scheme is "http" the web link should be opened
      // by some browser in the mobile
      await Linking.openURL(url);
    } else {
      Alert.alert(`Don't know how to open this URL: ${url}`);
    }
  }, [url]);

  return <Button title={children} onPress={handlePress} />;
};

const bpsupplyLink = "https://www.bpsupplyinc.com/pump-selector";
const dfwcreativeLink = "https://dfwcreativemarketing.com";

const FluidViscosityDetailsScreen = props => {
  return (
    <SafeAreaView>
      <ScrollView style={styles.body}>
        <Image
          style={styles.fitLogo}
          source={require('../../assets/adaptive-icon.png')}
        />
        <Text style={styles.title}>Fluid Viscosity Details</Text>
        <Text style={styles.body}>
          Here are some graphics to explain...
        </Text>
        <Image
          style={styles.fit}
          source={require('../../assets/image003.jpg')}
        />
        <Image
          style={styles.fit}
          source={require('../../assets/image005.jpg')}
        />
        <View style={styles.linkView}>
          <OpenURLButton url={bpsupplyLink}>Contact BP Supply for Help</OpenURLButton>
          <OpenURLButton url={dfwcreativeLink}>App Design by DFW Creative Marketing</OpenURLButton>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  linkView: {
    paddingBottom: 10,
  },
  title: {
    fontSize: 35,
    padding: 5,
    backgroundColor: "rgb(137,24,0)",
    color: "white",
    borderWidth: 2,
    borderColor: "black"
  },
  body: {
    padding: 15
  },
  fitLogo: {
    resizeMode: 'contain',
    width: '100%',
    height: 250,
    backgroundColor: "white",
    borderColor: "black",
    borderWidth: 1,
    borderRadius: 10
  },
  fit: {
    resizeMode: 'contain',
    width: '100%',
    height: 250,
    backgroundColor: "white",
    borderColor: "black",
    borderWidth: 1,
    borderRadius: 10,
    paddingBottom: 10,
    paddingTop: 10,
    marginVertical: 10
  },
});

export default FluidViscosityDetailsScreen;
